module.exports = new __parcel__URL__("epic_asteroid.59a2bd17.png").toString();